export class PortalUserRequest {
    id: number;
    username: string;
    email: string;
    employeeId: number;
    attribute1: string;
    attribute2: string;
    attribute3: string;
    attribute4: string;
    attribute5: string;
    attribute6: string;
    attribute7: string;
    attribute8: string;
    attribute9: string;
    attribute10: string;
    roleIds: any;
}
